{
  "runStatus": {
    "DRAFT": "Draft",
    "CALCULATED": "Calculated",
    "APPROVED": "Approved",
    "PAID": "Paid",
    "CANCELLED": "Cancelled",
    "REVERSED": "Reversed"
  },
  "ruleStatus": {
    "ACTIVE": "In force",
    "SCHEDULED": "Scheduled",
    "ENDED": "Ended",
    "OFF": "Off"
  },
  "scope": {
    "OMANI": "Omani employees",
    "NON_OMANI": "Non-Omani employees",
    "ALL": "All employees"
  },
  "base": {
    "CONTRIBUTORY": "Contribution wage",
    "BASIC": "Basic salary",
    "GROSS": "Gross earnings"
  },
  "baseHint": {
    "CONTRIBUTORY": "The components marked as counting in the contribution wage, after unpaid days.",
    "BASIC": "The basic salary, after unpaid days.",
    "GROSS": "Every earning of the month."
  },
  "dayRateBasis": {
    "FIXED_30": "A month is 30 days",
    "CALENDAR": "The days of the month"
  },
  "wageBasis": {
    "BASIC": "Basic salary",
    "GROSS": "Gross salary"
  },
  "gratuityScope": {
    "NON_OMANI": "Non-Omani employees",
    "ALL": "All employees"
  },
  "kind": {
    "EARNING": "Earning",
    "DEDUCTION": "Deduction"
  },
  "payMethod": {
    "BANK": "Bank transfer (WPS)",
    "CASH": "Cash",
    "CHEQUE": "Cheque"
  },
  "severity": {
    "ERROR": "Error",
    "WARNING": "Warning",
    "INFO": "Note"
  },
  "alerts": {
    "NO_SALARY": "No salary on file for the month: nothing can be paid.",
    "NO_BASIC": "The salary has no basic salary: contributions and gratuity may be wrong.",
    "NET_NEGATIVE": "Net pay is below zero ({{net}}): reduce the deductions.",
    "MINIMUM_WAGE": "Below the Omani minimum wage: total {{total}} (minimum {{minimumTotal}}), basic {{basic}} (minimum {{minimumBasic}}).",
    "DEDUCTION_CAP": "Voluntary deductions of {{deductions}} are above the cap of {{cap}}.",
    "CEILING_APPLIED": "Contributions are on the ceiling of {{ceiling}}, not the wage of {{wage}}.",
    "MISSING_BANK_DETAILS": "Paid by bank but the bank code or IBAN is missing: the WPS file needs them.",
    "MISSING_CIVIL_ID": "No civil ID or resident card number: the WPS file needs it.",
    "SUSPENDED": "Suspended in this month: not paid while suspended.",
    "NO_CONTRIBUTION_RULES": "No contribution rule applies: check the contribution rules.",
    "ENDS_IN_PERIOD": "Leaves on {{date}}: paid up to that day, with the end of service settled.",
    "JOINS_IN_PERIOD": "Joined on {{date}}: paid from that day."
  },
  "runs": {
    "title": "Payroll runs",
    "subtitle": "One run a month: calculate, approve, pay",
    "new": "New payroll run",
    "newTitle": "New payroll run",
    "newBody": "A run pays the month’s employees on their salaries, with the inputs you enter before calculating it.",
    "create": "Create run",
    "created": "Payroll run for {{period}} created",
    "month": "Month",
    "year": "Year",
    "payDate": "Pay date",
    "payDateHint": "The day salaries reach the banks.",
    "note": "Note",
    "fields": {
      "period": "Month",
      "payDate": "Pay date",
      "status": "Status",
      "employees": "Employees",
      "gross": "Gross",
      "deductions": "Deductions",
      "net": "Net pay",
      "employerCost": "Employer cost"
    },
    "filters": {
      "status": "Status",
      "allStatuses": "All statuses",
      "year": "Year",
      "allYears": "All years"
    },
    "empty": {
      "title": "No payroll runs yet",
      "body": "Create the first run for a month.",
      "filteredTitle": "No run matches",
      "filteredBody": "Change the filters."
    }
  },
  "run": {
    "title": "Payroll run",
    "backToList": "Back to payroll runs",
    "payDate": "Pay date {{date}}",
    "calculated": "Calculated {{at}} by {{name}}",
    "approved": "Approved {{at}} by {{name}}",
    "paid": "Paid on {{date}} from {{account}}",
    "journal": "Salary journal",
    "paymentJournal": "Payment journal",
    "staleTitle": "Something changed since the calculation",
    "staleBody": "Employees, salaries, inputs, rules or settings changed, or an earlier month was approved or reversed, after this run was calculated. Calculate again before approving.",
    "CANCELLED": "Cancelled on {{date}}",
    "REVERSED": "Reversed on {{date}}: the salary journal was reversed",
    "alertsTitle": "{{errors}} errors · {{warnings}} warnings",
    "errorsBody": "A payslip with an error blocks approval.",
    "warningsBody": "Warnings do not block approval; check them before you approve.",
    "seeAlerts": "See the alerts",
    "totals": "Run totals"
  },
  "totals": {
    "employees": "Employees",
    "gross": "Gross",
    "deductions": "Deductions",
    "employeeContributions": "Employee contributions",
    "net": "Net pay",
    "employerContributions": "Employer contributions",
    "gratuityProvision": "Gratuity provision",
    "gratuityPaid": "Gratuity paid",
    "employerCost": "Employer cost"
  },
  "actions": {
    "calculate": "Calculate",
    "recalculate": "Calculate again",
    "approve": "Approve",
    "pay": "Record payment",
    "wps": "Download WPS file",
    "edit": "Edit pay date",
    "cancel": "Cancel run",
    "reverse": "Reverse"
  },
  "calculate": {
    "running": "Calculating…",
    "toast": "Payroll for {{period}} calculated"
  },
  "approve": {
    "title": "Approve the payroll for {{period}}?",
    "body": "Approving locks the run: its payslips can no longer change, and the salary journal is posted to the ledger.",
    "confirm": "Approve and post",
    "toast": "Payroll for {{period}} approved",
    "staleReason": "Something changed since the calculation: calculate again first.",
    "errorsReason": "{{n}} payslip errors block approval."
  },
  "pay": {
    "title": "Record salary payment",
    "body": "The date the bank paid the salaries and the account they left. The payment journal is posted.",
    "paidOn": "Paid on",
    "account": "Paid from",
    "accountHint": "The cash or bank account the salaries were paid from.",
    "chooseAccount": "Choose an account",
    "loadingAccounts": "Loading accounts…",
    "reference": "Bank reference",
    "confirm": "Record payment",
    "toast": "Payment of the {{period}} payroll recorded"
  },
  "reverse": {
    "title": "Reverse the payroll for {{period}}",
    "body": "The salary journal is reversed and the month can be run again. Do this only before salaries are paid.",
    "reason": "Reason",
    "confirm": "Reverse run",
    "toast": "Payroll for {{period}} reversed"
  },
  "cancel": {
    "title": "Cancel the payroll for {{period}}",
    "body": "The run is set aside; the month can be run again.",
    "reason": "Reason",
    "confirm": "Cancel run",
    "toast": "Payroll for {{period}} cancelled"
  },
  "edit": {
    "title": "Edit pay date and note",
    "confirm": "Save",
    "toast": "Run saved"
  },
  "wps": {
    "downloading": "Downloading…"
  },
  "tabs": {
    "label": "Payroll run",
    "payslips": "Payslips",
    "inputs": "Inputs",
    "contributions": "Contributions",
    "alerts": "Alerts"
  },
  "payslips": {
    "employee": "Employee",
    "paidDays": "Paid days",
    "basic": "Basic",
    "gross": "Gross",
    "deductions": "Deductions",
    "employeeContributions": "Contributions",
    "net": "Net pay",
    "alerts": "Alerts",
    "searchPlaceholder": "Employee name or number",
    "searchLabel": "Search payslips",
    "clearSearch": "Clear search",
    "emptySearch": "No payslip matches",
    "notCalculated": "Not calculated yet",
    "notCalculatedBody": "Calculate the run to make its payslips."
  },
  "inputs": {
    "intro": "Absences, overtime and one-off lines for this month. Saving one marks the run for calculating again.",
    "closed": "The run is closed: its inputs can no longer change.",
    "add": "Add input",
    "addTitle": "Add input",
    "editTitle": "Edit input",
    "body": "Days and hours of the month, and one-off lines of the variable components.",
    "edit": "Edit",
    "remove": "Remove",
    "removeTitle": "Remove these inputs?",
    "removeBody": "The employee is paid without them at the next calculation.",
    "removedToast": "Inputs removed",
    "actions": "Input actions",
    "save": "Save input",
    "toast": "Input saved; calculate the run again",
    "employee": "Employee",
    "days": "Days",
    "overtime": "Overtime",
    "adjustments": "One-off lines",
    "noAdjustments": "No one-off lines.",
    "component": "Component",
    "chooseComponent": "Choose a component",
    "amount": "Amount",
    "lineNote": "Note",
    "addLine": "Add line",
    "removeLine": "Remove line",
    "empty": "No inputs for this run.",
    "unpaidShort": "{{n}} unpaid",
    "sickShort": "{{n}} sick",
    "encashShort": "{{n}} encashed",
    "overtimeShort": "{{n}} h day",
    "nightShort": "{{n}} h night / rest / holiday",
    "fields": {
      "unpaidDays": "Unpaid days",
      "sickDays": "Sick days",
      "overtimeHours": "Overtime hours",
      "overtimeNightHours": "Night, rest-day and holiday overtime hours",
      "encashmentDays": "Leave days paid out",
      "note": "Note"
    }
  },
  "contributions": {
    "title": "Social Protection Fund schedule",
    "intro": "Each employee’s contribution wage and both shares of each rule.",
    "csv": "Download CSV",
    "employee": "Employee",
    "wage": "Contribution wage",
    "total": "Total",
    "employeeShare": "Employee",
    "employerShare": "Employer",
    "totals": "Totals for {{n}} employees",
    "empty": "No contributions in this run."
  },
  "alertsTab": {
    "ERROR": "Errors",
    "WARNING": "Warnings",
    "INFO": "Notes",
    "none": "The calculation found nothing to report.",
    "runLevel": "The whole run"
  },
  "payslip": {
    "title": "Payslip",
    "back": "Back to the {{period}} run",
    "period": "Month",
    "payDate": "Pay date",
    "employee": "Employee",
    "civilNumber": "Civil ID",
    "spfNumber": "SPF number",
    "hireDate": "Hired",
    "payMethod": "Paid by",
    "iban": "IBAN",
    "days": "Days of the month",
    "employed": "Employed",
    "daysInPeriod": "Days in the month",
    "paidDays": "Paid days",
    "unpaidDays": "Unpaid days",
    "sickDays": "Sick days",
    "overtimeHours": "Overtime hours",
    "overtimeNightHours": "Night / rest / holiday overtime",
    "earnings": "Earnings",
    "deductions": "Deductions",
    "gross": "Gross earnings",
    "totalDeductions": "Total deductions",
    "net": "Net pay",
    "employer": "Paid by the employer",
    "employerNote": "Paid by the employer on top of the salary, not deducted from it.",
    "totalEmployer": "Total employer contributions",
    "item": "Item",
    "amount": "Amount",
    "none": "None",
    "alerts": "Alerts",
    "hours": "h",
    "daysShort": "d",
    "percentOf": "{{rate}}% of {{base}}",
    "footer": "Amounts in Omani rials (<rial/>).",
    "commissionStatement": "Open the commission statement"
  },
  "rules": {
    "title": "Contribution rules",
    "subtitle": "Social Protection Fund rates by branch, for Omani and non-Omani employees",
    "noteTitle": "These rates are the company’s data",
    "noteBody": "Each rule is a rate the company keeps. Check them against the Social Protection Fund’s current rates; a change in the law is a new row from its start date, never an edit of an applied one.",
    "add": "Add rule",
    "addTitle": "Add contribution rule",
    "edit": "Edit",
    "editTitle": "Edit {{code}}",
    "save": "Save rule",
    "delete": "Delete",
    "deleteTitle": "Delete {{code}}?",
    "deleteBody": "The rule is removed. Runs already approved keep what they priced.",
    "deletedToast": "{{code}} deleted",
    "addedToast": "{{code}} added",
    "savedToast": "{{code}} saved",
    "loadPreset": "Load Oman preset",
    "presetToast_one": "{{n}} rule loaded",
    "presetToast_other": "{{n}} rules loaded",
    "inUse": "Applied on a run",
    "inUseReason": "Applied on an approved run: end it instead.",
    "inUseNote": "This rule was applied on an approved run: its code, scope, rates, base, ceiling and start stay as they are. End it and add a new rule for a new rate.",
    "actionsFor": "Actions for {{code}}",
    "scopeEmpty": "No rules for these employees.",
    "ceilingShort": "up to",
    "noEnd": "no end",
    "employeeRateHint": "Deducted from the employee’s pay, in percent.",
    "employerRateHint": "Paid by the employer on top of the pay, in percent.",
    "ceilingHint": "The most of the base a month the rates apply to; empty: no ceiling.",
    "effectiveToHint": "Empty: in force until ended.",
    "fields": {
      "code": "Code",
      "name": "Rule",
      "nameEn": "Name in English",
      "nameAr": "Name in Arabic",
      "scope": "Applies to",
      "employeeRate": "Employee %",
      "employerRate": "Employer %",
      "base": "Base",
      "ceiling": "Ceiling",
      "dates": "In force",
      "effectiveFrom": "From",
      "effectiveTo": "Until",
      "source": "Source",
      "status": "Status",
      "active": "Switched on"
    },
    "empty": {
      "title": "No contribution rules yet",
      "body": "Load the Oman preset, then check each rate against the Social Protection Fund."
    }
  },
  "settings": {
    "title": "Payroll settings",
    "subtitle": "How payroll pays and what it checks",
    "updated": "Last changed {{at}} by {{name}}",
    "readOnlyTitle": "Read only",
    "readOnlyBody": "Changing payroll settings needs the payroll settings permission.",
    "save": "Save settings",
    "discard": "Discard changes",
    "saved": "Payroll settings saved",
    "fix": "Some fields need attention.",
    "notSaved": "Not saved",
    "conflict": "Someone else changed the settings meanwhile. Reload the page to see their version.",
    "wps": {
      "title": "Wage Protection System",
      "body": "The employer and payer in the WPS salary file.",
      "employerCr": "Employer CR number",
      "employerCrHint": "Empty: the company profile’s CR number.",
      "payerBankCode": "Payer bank code",
      "payerAccount": "Payer account"
    },
    "days": {
      "title": "Pay days",
      "dayRateBasis": "A day’s pay",
      "basisHint": {
        "FIXED_30": "A month’s pay divided by 30, whatever the month (Omani practice).",
        "CALENDAR": "A month’s pay divided by the days of that month."
      },
      "encashmentBase": "Leave encashment wage",
      "encashmentHint": "A paid-out leave day is this wage divided by 30."
    },
    "overtime": {
      "title": "Overtime",
      "base": "Overtime wage",
      "divisor": "Hours in a month",
      "divisorHint": "An hour’s pay is the overtime wage divided by this (240 = 30 days × 8 hours).",
      "dayRate": "Day overtime rate",
      "dayRateHint": "× 1.25 under the Labour Law.",
      "nightRate": "Night, rest-day and holiday rate",
      "nightRateHint": "× 1.5 under the Labour Law.",
      "contributory": "Overtime counts in the contribution wage"
    },
    "sick": {
      "title": "Sick leave",
      "body": "Sick-day pay over a calendar year in bands; days after the last band are unpaid.",
      "toDay": "Up to day",
      "payPercent": "Pay %",
      "add": "Add band",
      "remove": "Remove band"
    },
    "gratuity": {
      "title": "End-of-service gratuity",
      "body": "Accrued every month as a provision and paid in the month the employee leaves.",
      "enabled": "Pay end-of-service gratuity",
      "scope": "Who earns it",
      "minService": "Minimum service (years)",
      "minServiceHint": "Below it nothing is paid at exit; the provision still accrues.",
      "accrualUntil": "Accrues until",
      "accrualUntilHint": "Service after this date earns no gratuity (the savings scheme replaces it).",
      "proRata": "Part years count pro rata",
      "tiers": "Days of wage per year of service",
      "fromYear": "From year",
      "daysPerYear": "Days a year",
      "addTier": "Add tier",
      "removeTier": "Remove tier"
    },
    "checks": {
      "title": "Checks",
      "minimumWage": "Omani minimum wage (total)",
      "minimumHint": "Payslips below it are flagged; 0 turns the check off.",
      "minimumBasic": "Omani minimum basic salary",
      "deductionCap": "Deduction cap %",
      "deductionCapHint": "Voluntary deductions above this share of gross are flagged.",
      "makerChecker": "Whoever calculates a run cannot approve it",
      "makerCheckerHint": "Maker-checker: approval needs a second person."
    }
  },
  "validation": {
    "percent": "Enter a percentage with up to 4 decimals",
    "atMost100": "At most 100",
    "rate": "Enter a rate with up to 2 decimals",
    "rateRange": "Between 1 and 5",
    "number": "Enter a number with up to 2 decimals",
    "hours": "Enter hours with up to 2 decimals",
    "atLeastOne": "At least 1",
    "bandOrder": "Must come after the band before",
    "firstTier": "The first tier starts at 0",
    "tierOrder": "Must come after the tier before",
    "ruleCode": "Use 2–40 letters, digits or underscores, starting with a letter",
    "someRate": "Give the employee or employer rate",
    "endBeforeStart": "Ends before it starts",
    "positive": "Must be more than zero"
  },
  "errors": {
    "PAYROLL_PERIOD_TAKEN": "This month already has a run. Cancel or reverse it first.",
    "PAYROLL_RUN_STATUS": "This cannot be done in the run’s current status. Reload the page to see it.",
    "PAYROLL_NOT_CALCULATED": "Calculate the run before approving it.",
    "PAYROLL_STALE": "Something changed since the calculation. Calculate again, then approve.",
    "PAYROLL_HAS_ERRORS": "A payslip has an error (no salary, net below zero). Fix it and calculate again.",
    "PAYROLL_SAME_PERSON": "You calculated this run, so someone else must approve it.",
    "TREASURY_ACCOUNT_INVALID": "Choose an active cash or bank account the salaries were paid from.",
    "WPS_NOT_SET_UP": "The WPS file needs the employer’s CR number and the payer bank and account. Fill them in Payroll settings.",
    "PAYROLL_EMPLOYEE_NOT_IN_PERIOD": "This employee is not employed in the run’s month.",
    "PAYROLL_OUT_OF_ORDER": "Months are approved in order: approve or cancel the earlier month first, or reverse the later month first.",
    "CONTRIBUTION_RULE_IN_USE": "This rule was applied on an approved run: its rates and dates cannot change. End it and add a new rule.",
    "CONTRIBUTION_RULE_DUPLICATE": "Another rule has this code from the same date."
  }
}
